module.exports = __webpack_public_path__ + "static/media/ValerieSanchez.2f5d7b39.webp";